import { ReactNode } from 'react'
import { ModuleName } from '../../../enums/enums'
import ImgBgCocaine from '../../../assets/images/level1-bg.png'
import ImgBgXanax from '../../../assets/images/level2-bg.png'
import ImgBgMdma from '../../../assets/images/level3-bg.png'
import ImgBgResponse from '../../../assets/images/level4-bg.png'

export const defaultModuleBgImg = ImgBgResponse

// Per-module background definition
export const moduleBackgrounds: Map<ModuleName, string> = new Map([
  [ModuleName.Cocaine, ImgBgCocaine],
  [ModuleName.Xanax, ImgBgXanax],
  [ModuleName.Mdma, ImgBgMdma],
  [ModuleName.Response, ImgBgResponse],
  [ModuleName.Lightning, defaultModuleBgImg]
])

interface ModuleBackgroundProps {
  children: ReactNode | ReactNode[]
  moduleName: ModuleName | null
  className?: string
  [rest: string]: any
}

const ModuleBackground: React.FC<ModuleBackgroundProps> = ({ children, moduleName, className, ...rest }) => {
  let bgImg: string = defaultModuleBgImg

  if (className === null || className === undefined) {
    className = ''
  }

  if (moduleName !== null) {
    let img = moduleBackgrounds.get(moduleName)
    if (img === undefined) {
      img = defaultModuleBgImg
    }

    bgImg = img
  }

  return (
    <div
      data-testid='background'
      className={`!bg-cover font-primary w-full h-screen ${className}`}
      style={{ background: `url(${bgImg}) no-repeat` }}
      {...rest}
    >
      {children}
    </div>
  )
}

export default ModuleBackground
